define.alias("ember-math-helpers/helpers/asin", "media/helpers/asin");